module.exports = __webpack_public_path__ + "static/img/14000617.8098dd5d.png";